/**
 * OctoLab (nesne tasarımcısı) adresi. Web'deki `octoLabOpener.resolveUrl` ile aynı yol.
 *
 * Paylaşılan katmanda: hem grid'in sağ tık menüsü hem kullanıcı menüsü açıyor ve iki yerde
 * ayrı yazıldığında yollar birbirinden kayıyordu (biri /octolab, diğeri /octo-lab).
 */
export function octoLabUrl(objectId?: string | null): string {
  return objectId ? `/octo-lab/${objectId}` : '/octo-lab';
}
